// `updater_name` on a timeline event can be either a person's full name or a system actor
// (an integration that created/updated the contact through the v2 lead endpoints). Renderers
// must not assume it is a person.

export const SERVICE_UPDATER_TYPE = "service";

export const isServiceUpdater = (timelineFields = {}) =>
  timelineFields.updater_type === SERVICE_UPDATER_TYPE;

export default isServiceUpdater;
